import { useSelector } from "react-redux";
import { Imgs } from "../../img/Imgs/Imgs";
import Community from "../Community/Community";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";

const Story = () => {
  const selectedLanguages = useSelector(selectedLanguage);

  return (
    <section className="story">
      <div className="story__container container">
        <Community />
        <h2>{translations[selectedLanguages].story.title}</h2>
        <p>{translations[selectedLanguages].story.description}</p>
        <div className="story__context">
          <div className="story__context-item">
            <img src={Imgs.storyfirst} alt="storyimg" />
            <div className="story__context-item-info">
              <h3>{translations[selectedLanguages].story.firstItemTitle}</h3>
              <p>{translations[selectedLanguages].story.firstItemContext}</p>
            </div>
          </div>
          <div className="story__context-item">
            <img src={Imgs.storysecond} alt="storyimg" />
            <div className="story__context-item-info">
              <h3>{translations[selectedLanguages].story.secondItemTitle}</h3>
              <p>{translations[selectedLanguages].story.secondItemContext}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Story;
